import _sfc_main from "./FlowDropdown.vue2.js";
import "./FlowDropdown.vue3.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const FlowDropdown = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2961e3d4"]]);
export {
  FlowDropdown as default
};
//# sourceMappingURL=FlowDropdown.vue.js.map
